import { LMS_WEBAPP_CONFIG_IMPL } from "../../../infecto-lms-webapp-impl/config";
import { safeBase64Encode } from "../../utils/safeUrlBaseGenerator";

export const selectRouteToIdentity = (status: "registration" | "login") => {
	if (status == "registration") {
		return `${process.env.REACT_APP_USER_SYSTEM_BASE}/logout/${LMS_WEBAPP_CONFIG_IMPL.brandId}/${safeBase64Encode(`${process.env.REACT_APP_USER_SYSTEM_BASE}/registration/${LMS_WEBAPP_CONFIG_IMPL.brandId}`)}`;
	} else if (status == "login") {
		return `${process.env.REACT_APP_USER_SYSTEM_BASE}/logout/${LMS_WEBAPP_CONFIG_IMPL.brandId}/${safeBase64Encode(`${process.env.REACT_APP_USER_SYSTEM_BASE}/login/${LMS_WEBAPP_CONFIG_IMPL.brandId}`)}`;
	}
};
